<template>
  <v-dialog v-model="show" width="786px" persistent>
    <!-- <template v-slot:activator="{ on }"> </template> -->
    <div class="modal">
      <v-card flat>
        <v-row>
          <div class="icon-modal table-cell">
            <v-layout class="delete-warning-icon">
              <v-flex>
                <img :src="require('@/assets/img/warning.svg')" alt=""/>
              </v-flex>
            </v-layout>
          </div>
          <v-col class="table-cell modal-content">
            <div class="d-flex justify-space-between">
              <h6 class="modal-title mb-5" style="visibility: hidden">Delete ALL</h6>
            </div>

            <div v-if="deleting_status === ''" v-html="title"></div>

            <div v-if="deleting_status === 'complete'">
              Previous Data has been deleted, please login to your new permission level
            </div>
            <div v-if="deleting_status === 'loading'" class="mt-10 mb-10 buttons d-flex">
              <v-progress-linear
                  color="primary"
                  indeterminate
                  rounded
                  height="6"
              />
            </div>
            <div v-if="deleting_status === 'complete'" class="mt-10 mb-10 buttons d-flex">
              <v-btn
                  class="mt-5 btn-azul few"
                  rounded
                  depressed
                  @click="hide"
              >
                OK
              </v-btn>
            </div>
            <div v-if="deleting_status === ''" class="mt-10 mb-10 buttons d-flex">
              <v-btn
                  class="mt-5 btn-blanco few"
                  rounded
                  depressed
                  @click="onConfirm"
              >YES
              </v-btn>
              <v-btn
                  class="mt-5 btn-azul few"
                  rounded
                  depressed
                  @click="hide"
              >NO
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </v-card>
    </div>
  </v-dialog>
</template>

<script>
  import {mapState} from "vuex";

  export default {
    props: {
      show: {
        type: Boolean,
        default: false
      },
      hide: {
        type: Function,
        default: () => {
        }
      },
      title: {
        type: String,
        default: ""
      },
      confirm: {
        type: Function,
        default: () => {
        }
      }
    },
    data: () => ({
      image: require("@/assets/logo.svg")
    }),
    computed: {
      ...mapState({
        deleting_status: state => state.Authenticate.deleting_status,
      })
    },
    components: {},
    methods: {
      close() {
        this.hide();
      },
      onConfirm() {
        this.confirm();
      }
    },
  };
</script>
